import React from 'react'
import Box from '@mui/material/Box'; 
import TextField from '@mui/material/TextField'; 
import Typography from '@mui/material/Typography'; 

function SecurityComp(props) { 
  return (
    <Box sx={{p: 5, background: "#ffffff"}} >
      <Typography align='center' variant='h5' sx={{mb: 5}} >This site is password protected and for personal use only.</Typography>
      <TextField sx={{mb: 5}} label='Password' fullWidth value={props.password} onChange={props.onChange} />
    </Box>)
}

export default SecurityComp;
